import React, { useEffect, useRef } from 'react'
import { useAuth } from '@praxis/component-auth'
import { NavLink, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Layout } from '@enterprise-ui/canvas-ui-react'
import { Header, SideNavigation, itemCommonUtilis } from 'item-component'
import Grid from '@material-ui/core/Grid'
import '@enterprise-ui/canvas-ui-css'
import withHOCs from 'util/withHocs'
import LayoutRouter from './LayoutRouters'
import '../../../src/styles/layout.css'
import { saveUser } from '../../store/user/actionCreator'
import { isSessionActive, sideNavMenuList } from 'util/CommonUtils'
import apiConfig from 'apiConfig'
import { handleFireflySendEvent } from 'util/fireflyUtils'

const styles = (theme) => ({
  contentContainer: {
    gridColumn: '1 / span 4',
    padding: theme.spacing(1), // Default <Grid container> spacing is 16. Use 8px padding for bug in material-ui Grid. See https://github.com/callemall/material-ui/issues/7466#issuecomment-316356427
    marginTop: 50,
    // marginLeft: 50,
  },
  contentContainerParent: {
    gridColumn: '2 / span 4',
  },
})

const LayoutItemHub = (props) => {
  const dispatch = useDispatch()
  const authValue = useAuth()
  const { session = {} } = authValue
  const { classes, auth } = props
  const { isAuthenticated = () => {}, isAuthorized = () => {} } = auth
  const finalSideNavMenuList = (sideNavMenuList || [])?.filter((obj) =>
    isAuthorized(obj?.adgroups || [])
  )
  const location = useLocation()
  const previousPathRef = useRef(null)
  const path =
    typeof window !== 'undefined' && window.location?.pathname
      ? window.location.pathname
      : location?.pathname || '/'
  const pageName =
    (sideNavMenuList || []).find(
      (menu) => path === menu.path || path.startsWith(`${menu.path}/`)
    )?.name || path

  useEffect(() => {
    if (previousPathRef.current !== path) {
      handleFireflySendEvent(
        'PAGE_VIEW',
        pageName,
        `${pageName}+_APPLICATION_LOAD_ITEMHUB`,
        session
      )
      previousPathRef.current = path
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, session])

  useEffect(() => {
    const { isAuthenticated = () => {}, hasExpired, login = () => {} } = auth
    if (hasExpired || !isAuthenticated()) {
      login({ redirect: window.location.href })
    } else {
      authChecks()
    }
  }, [])

  const authChecks = () => {
    const { login = () => {} } = auth
    const isSessionActiveProp = isSessionActive({ auth })
    if (!isSessionActiveProp) {
      login({ redirect: window.location.href })
    } else {
      dispatch(saveUser())
    }
  }

  if (isAuthenticated()) {
    return (
      <Layout darkMode={false} data-testid="layout_itemhub_pegasus">
        <Header userRole={'user role'} useAuth={useAuth} />
        <SideNavigation
          className="side-navigation-panel"
          data-testid="item-app-sidenav-panel"
          startExpanded={itemCommonUtilis.isItemHub}
          appMenus={finalSideNavMenuList}
          defaultmenurequired={itemCommonUtilis.isItemHub}
          isMinimized={!itemCommonUtilis.isItemHub}
          clientApp={'pegasus'}
          LinkComponent={NavLink}
          currentPath={path}
          itemHubApiKey={apiConfig.itemHubapiKey}
        />
        <Layout.Body
          includeRail={false}
          className={classes.contentContainerParent}
        >
          <div className={classes.contentContainer}>
            <Grid container>
              <Grid item xs={12}>
                <LayoutRouter />
              </Grid>
            </Grid>
          </div>
        </Layout.Body>
      </Layout>
    )
  } else {
    return ''
  }
}
export default withHOCs({
  auth: true,
  nav: true,
  styles,
  connectParams: {},
})(LayoutItemHub)
